import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../@communityshare/ui/Button';
import { SolidButton } from '../../@communityshare/ui/Button';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit,
    onClose,
    supportQuestion
  } = props;

  return (
    <FormTemplate
      textAlign="left"
      title="Delete support question"
      subtitle={(
        <>
          <span className="block">
            Are you sure you want to remove the following support question?
          </span>
        </>
      )}
      onClose={onClose}
      alert={alert}
      body={(
        <div className="font-semibold text-cs-gray-700">
          {supportQuestion.data.question}
        </div>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Delete support question
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
